import { ComboCostDTO, defaultComboCostDTO } from "../ComboCostDTO";

export interface ComboMPPDTO extends ComboCostDTO {
    substanceandpresentation: string | null;
    unitsperpackage?: number | null;
    // Solo front: el catálogo no trajo unidades por envase, así que se pueden cargar a mano hasta guardar el presupuesto
    unitsperpackageeditable?: boolean;
}

export const defaultComboMPPDTO:ComboMPPDTO = {
    ... defaultComboCostDTO,
    substanceandpresentation: '',
}